// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"353":"contact","594":"about","671":"services","962":"home"}[chunkId] || chunkId) + "." + {"348":"7f46132b","353":"9886341f","594":"96eca1a6","671":"16a0bd63","930":"86b9f7ff","962":"cf1d4a13"}[chunkId] + ".js";
};